import React from "react";

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50  overflow-x-hidden py-0 md:py-6 lg:py-6 overflow-auto h-[100vh]">
      <div className="max-w-5xl mx-auto bg-white shadow-md rounded-lg p-6">
        {/* <div className="flex justify-center items-center border border-black rounded-2xl max-w-[80px]  h-[30px]">
          <a href="/#home" className="text-center text-[12px] text-[#187CFF] block no-underline">
            Go Home
          </a>
        </div> */}

        <div className="flex justify-center mb-10">
          <img
            src="/assests/ceviliyar_mainLogo.png"
            alt="Rizz Logo"
            className="w-[138px] h-[37px]"
          />
        </div>

        <h1 className="text-2xl font-bold text-gray-800 mb-4">
          Terms of Service
        </h1>
        <p className="text-gray-600 mb-6">Effective Date: December 16, 2024</p>
        <p className="text-gray-700 mb-4">
          Welcome to Rizz Software Solutions Private Limited ("Company," "we,"
          "our," or "us"). These Terms of Service ("Terms") govern the use of
          our mobile application ("Ceviliyar App") and platform for connecting
          patients with qualified healthcare professionals, including nurses and
          physiotherapists ("Healthcare Providers"). By accessing or using our
          services, you agree to be bound by these Terms.
        </p>
        <p className="text-gray-700 mb-4">
          If you do not agree to these Terms, you may not access or use our
          services.
        </p>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            1. About the Platform
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              Ceviliyar App enables patients to search for, book, and engage
              nurses and physiotherapists for home healthcare services.
            </li>
            <li>
              The Company acts solely as a facilitator, providing a platform to
              connect patients with Healthcare Providers.
            </li>
            <li>
              Healthcare Providers listed on our platform are independent
              contractors, not employees, agents, or representatives of the
              Company.
            </li>
            <li>
              The Company validates the credentials (certificates and Aadhaar
              card) of Healthcare Providers during onboarding but does not
              guarantee the quality, safety, or outcomes of the services
              provided.
            </li>
            <li>
              Patients can rate Healthcare Providers after each service through
              the Ceviliyar App.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            2. Registration and Onboarding
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              Healthcare Providers are required to pay a one-time,
              non-refundable registration fee of ₹250.00 during the onboarding
              process. Promotional offers or discounts may apply from time to
              time, as determined by the Company.
            </li>
            <li>
              Healthcare Providers can set their service location and
              availability preferences through the Ceviliyar App and upon
              successful validation of credentials, their profile will be
              activated.
            </li>
            <li>
              Patients can search for providers based on their preferences and
              book services directly through the Ceviliyar App.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            3. Scope of Services
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              The Platform serves as a facilitator between patient and
              healthcare providers such as nurse and physiotherapists. We do not
              provide medical advice or diagnose medical conditions. Our
              services are not a substitute for professional medical
              consultation, diagnosis, or treatment.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            4. Fees and Commission
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              Patients are charged the provider’s fee plus GST for each booking.
            </li>
            <li>
              The company retains a commission from health care providers, such
              as nurses or physiotherapists, as specified in the Independent
              Contractor Agreement, deducted from the fee paid by the patient.
            </li>
            <li>
              Tax Deducted at Source (TDS) will be deducted from Health Care
              Providers at the rate of 1% if a single payment is above ₹30,000
              or if total payments during the financial year are above
              ₹1,00,000, in line with the applicable threshold limits.
            </li>
            <li>
              Health Care Providers participating in the "On Call" list will be
              receive an incentive of additional 10% payment on their fees.
            </li>
            <li>
              As independent contractors, Healthcare Providers are responsible
              for their own taxes, regulatory compliance, and professional
              conduct. The Company does not provide employment benefits such as
              insurance, paid leave, or retirement contributions.
            </li>
          </ul>
        </section>
        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            5. PaymentTerms
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              Healthcare Providers are paid weekly for their completed services.
              Payments are contingent upon confirming and completing duties as
              recorded in Ceviliyar App.
            </li>
            <li>
              Healthcare Providers must press the “Start Duty” and “End Duty”
              buttons in the Ceviliyar App to document their work and ensure
              payment. Failure to follow this process may result in non-payment.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            6. No Refunds and Replacement Policy
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              No refunds will be provided for services booked through the
              platform.
            </li>
            <li>
              If a patient is dissatisfied with the assigned Healthcare
              Provider, they may contact the Company’s People Relationship
              ORicer at{" "}
              <a
                href="mailto:pro@rizzsoftware.com"
                style={{ textDecoration: "underline", color: "blue" }}
              >
                {" "}
                pro@rizzsoftware.com ,
              </a>
              The People Relationship ORicer will assist in replacing the
              Healthcare Provider with another qualified professional at no
              additional platform fee.
            </li>
            <li>
              Patients can provide feedback and rate Healthcare Providers after
              each service. These ratings help maintain service quality and
              transparency across the platform.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            7. Professional Conduct
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              Both patients and Healthcare Providers are required to act
              professionally and respectfully.
            </li>
            <li> The Company is not liable for:</li>
            <li>Theft,loss,or damage to property at the patient’s home.</li>
            <li>
              {" "}
              In appropriate behavior,including harassment or assault,by either
              party.
            </li>
            <li>
              Ceviliyar App includes an SOS feature for health care providers to
              notify emergency contacts in case of incidents at a patient’s
              home. However, its use does not imply liability on the part of the
              company for any such incidents.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            8. Cancellations and Penalties
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              On the day of duty, Healthcare Providers must confirm their
              availability two hours before their scheduled duty through
              Ceviliyar App notification services.
            </li>
            <li>
              Healthcare Providers who fail to fulfill their duties without
              proper notice will face penalties as follows:
            </li>
            <li>
              Penalty for First Day No-Show/Cancellation: Immediate profile
              deactivation and a ₹300.00 re activation fee.
            </li>
            <li>
              Penalty for Same-Day No-Show/Cancellation {"<"} 12 hours: 30% of
              the day’s earnings.
            </li>
            <li>Penalty for 12–24 Hours’ Notice: 20% of the day’s earnings.</li>
            <li>Penalty for 24–48 Hours’ Notice: 15% of the day’s earnings.</li>
            <li>Other Cancellations: 10% of the day’s earnings.</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            9. On Call List
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              Healthcare Providers may join the {"On Call"} list to serve as
              substitutes for unfulfilled bookings.
            </li>
            <li>
              {" "}
              Providers on the {"On Call"} list are prioritized for backup
              assignments and earn higher payouts with reduced commission rates.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            10. Data Privacy and Confidentiality
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              Healthcare Providers are required to maintain the confidentiality
              of all patient information obtained during the course of providing
              services. This includes but is not limited to personal details,
              medical history, and treatment plans.
            </li>
            <li>
              Patient information must not be shared, disclosed, or used for any
              purpose other than delivering the agreed-upon healthcare services.
              Any breach of confidentiality may result in termination from the
              platform and legal action in accordance with applicable laws.
            </li>
            <li>
              The Company complies with the Information Technology Act, 2000,
              and related rules regarding data privacy. By using the platform,
              users agree to our
              <a
                href="https://ceviliyar.in/privacyPolicy"
                style={{ textDecoration: "underline", color: "blue" }}
              >
                {" "}
                Privacy Policy
              </a>
              , which outlines how we collect, store, and use personal
              information.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            11. Limitations of Liability
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              The Company acts solely as a technology platform to connect
              patients with Healthcare Providers and is not responsible for:
              <ul className="list-disc list-inside ml-6">
                <li>The outcome or quality of services provided.</li>
                <li>
                  Any incidents or disputes arising between patients and
                  providers.
                </li>
              </ul>
            </li>
            <li>
              Healthcare Providers are independent contractors, and the Company
              disclaims liability for acts, omissions, or services rendered by
              them during their engagement with patients.
            </li>
            <li>
              Users agree to indemnify and hold harmless the Company against any
              claims, damages, or losses resulting from their use of the
              platform.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            12. Termination of Service
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              The Company reserves the right to deactivate or terminate accounts
              for violations of these Terms, unprofessional conduct, or failure
              to comply with penalty policies.
            </li>
            <li>
              Healthcare Providers found violating confidentiality obligations
              will face immediate termination from the platform and may be
              subject to further legal action.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            13. Governing Law
          </h2>
          <p className="text-gray-700">
            These Terms are governed by the laws of India. Disputes shall be
            resolved exclusively in the courts of Chennai, India.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            14. Amendments
          </h2>
          <p className="text-gray-700">
            The Company reserves the right to amend these Terms of Service at
            its discretion. Updated terms will be posted in the Ceviliyar App,
            and continued use of the platform constitutes acceptance.
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-lg font-semibold text-gray-800">Contact Us</h2>
          <p className="text-gray-700 mt-2">
            For questions or concerns regarding these terms, contact us at:
          </p>
          <p className="text-blue-700 font-bold mt-2 ">
            Rizz Software Solutions Private Limited
          </p>
          <p className="text-gray-700">Level 8 & 9 Olympia Teknos</p>
          <p className="text-gray-700">No 28 SIDCO Industrial Estate</p>
          <p className="text-gray-700">Guindy, Chennai 600032</p>
          <p className="text-gray-700">Email : support@rizzsoftware.com</p>
          <p className="text-gray-700 text-[14px]">Phone: +91 9445318886</p>
          <p className="ml-12 text-[14px]"> +91 9445318887</p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
